import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const WalletBalanceSummary = ({ balance, loading, error, className = '' }) => {
  const { t, i18n } = useTranslation('dashboard');

  const formatEur = useMemo(() => {
    try {
      return new Intl.NumberFormat(i18n.language || 'ua', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    } catch (formatError) {
      return new Intl.NumberFormat('en', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    }
  }, [i18n.language]);

  const summaryClassName = className ? `balance-summary ${className}` : 'balance-summary';

  return (
    <div className={summaryClassName}>
      <p className="balance-summary__value">
        {loading
          ? t('billing.summary.loading')
          : t('billing.summary.value', { amount: formatEur.format(Number(balance) || 0) })}
      </p>
      {error && <p className="form-error">{error}</p>}
    </div>
  );
};

export default WalletBalanceSummary;
